import React from 'react';
import DateUtils from 'js/lib/DateUtils';
import { sanitizeApiKey } from 'js/lib/URLUtils';
import CopyText from 'js/components/elements/CopyText';
import { ServiceKey } from '@nexla/@types';

type ServiceKeyOverviewProps = {
  isPreSelected: boolean;
  data: ServiceKey;
  parentScrollRef: HTMLElement;
};

export function ServiceKeyOverview(props: ServiceKeyOverviewProps) {
  const { data } = props;

  const createdDate = DateUtils.convertDateStringToFormat(data.created_at);
  const lastUpdate = DateUtils.convertDateStringToFormat(data.updated_at);

  return (
    <div className="tab-content data-map-overview-tab">
      <section>
        <div className="detail-row">
          <div className="detail-col">
            <div className="detail-key">API Key</div>
            <div className="detail-value">
              <CopyText baseText={data.api_key} displayText={sanitizeApiKey(data.api_key)} />
            </div>
          </div>
          <div className="detail-col">
            <div className="detail-key">Service Key ID</div>
            <div className="detail-value">{data.id}</div>
          </div>
        </div>
        <div className="detail-row">
          <div className="detail-col">
            <div className="detail-key">Created On</div>
            <div className="detail-value">{createdDate}</div>
          </div>
          <div className="detail-col">
            <div className="detail-key">Last Updated On</div>
            <div className="detail-value">{lastUpdate}</div>
          </div>
        </div>
      </section>
    </div>
  );
}
